module.exports = "/_next/static/images/b61e1988c875af5e02db21eca55b5887-footer-fogafin-4x.png.webp";